import React from 'react';
import TaskListManagement from '../components/tasks/TaskListManagement';

const GlobalTasks: React.FC = () => {
  return (
    <div className="py-6">
      <TaskListManagement
        title="All Tasks"
        description="View and manage tasks across all projects"
        showProjectSelector={true}
      />
    </div>
  );
};

export default GlobalTasks;
